<template>
  <div class="pa-3">
    <v-row v-if="!isClient">
      <v-col cols="12" xs="6" md="6">
        <v-btn  class="mr-2 primary" @click="exportExcel" small>
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="right" align="center">
      <v-col class="d-flex flex-row" cols="12" md="12" lg="12" sm="12" align="center" justify="center">
        <v-autocomplete
          filled
          :items="campaigns"
          label="Campaign"
          hide-details
          item-text="name"
          item-value="id"
          :return-object="true"
          v-model="filteredCampaign"
          @change="searchFilter"
          clearable
        >
          <template v-slot:item="{ item }">
            <div>
              {{item.name}}&nbsp;&nbsp;
              <v-chip color="error" v-if="item.lockedCOGS && !isClient" small>
                <span style="color:#fff"><v-icon v-on="on" small left>mdi-lock</v-icon> Locked COGS</span>
              </v-chip>
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="pt-0">
      <v-col class="pt-0" cols="12" sm="7" md="7" lg="7">
        <div class="d-flex flex-row" style="float:right;" v-if="!isClient">
          <v-autocomplete
            style="min-width:300px;max-width:300px;padding-top:10px;"
            :items="filterStatuses"
            item-value="value"
            item-text="text"
            label="Status"
            v-model="filters.status"
            hide-details
            outlined
            dense
            clearable
          ></v-autocomplete>
        </div>
      </v-col>
      <v-col class="pt-0" cols="12" sm="5" md="5" lg="5">
        <div class="d-flex flex-row">
          <v-text-field v-model="filters.keyword" append-icon="search" label="Search" single-line hide-details></v-text-field>
          <v-btn @click="searchFilter" color="secondary" small class="ml-2 mt-4">Apply</v-btn>
          <v-btn @click="resetFilter" small class="ml-2 mt-4">Reset</v-btn>
        </div>
      </v-col>
    </v-row>
    <div class="text-right" v-if="filteredCampaign && !isClient">
      <v-menu
        :close-on-content-click="false"
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="secondary"
            v-bind="attrs"
            v-on="on"
            @click="openColSettingsModal"
          >
            <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
          </v-btn>
        </template>
      </v-menu>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="computedHeaders"
          :items="filteredItems"
          item-key="dataTableKey"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :footer-props="{
            itemsPerPageOptions: rowsPerPageItems
          }"
          :items-per-page="20"
          :no-data-text="'Empty list'"
          class="elevation-1 creator_concept_page__table"
        >
          <template v-slot:[`item.userHandle`]="{ item }">
            <div class="text-left">
              <social-handle
                divClassName="d-inline"
                :isTikTok="item.platform === 'tiktok'"
                :isInstagram="item.platform === 'instagram'"
                :isFacebook="item.platform === 'facebook'"
                :isLinkedIn="item.platform === 'linkedin'"
                :isTwitter="item.platform === 'twitter'"
                :isYoutube="item.platform === 'youtube'"
                :isXiaohongshu="item.platform === 'xiaohongshu'"
                :tiktokHandle="item.userHandle"
                :instagramHandle="item.userHandle"
                :facebookHandle="item.userHandle"
                :linkedinHandle="item.userHandle"
                :twitterHandle="item.userHandle"
                :youtubeHandle="item.userHandle"
                :xiaohongshuHandle="item.xhsID"
                :xiaohongshuFullName="item.fullName"
                :youtubeURL="item.url"
              />
              <v-tooltip v-if="item.influencerID" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click="true" color="green" v-on="on">done</v-icon>
                </template>
                <span>Registered on IMS</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.campaignName`]="{ item }">
            <div class="text-left">
              {{item.campaignName}}
            </div>
          </template>
          <template v-slot:[`item.conceptStatus`]="{ item }">
            <div class="text-left">
              <div class="d-flex flex-row" v-if="item.conceptStatusEdit">
                <v-select
                  style="max-width:320px"
                  :items="conceptStatuses"
                  item-text="text"
                  item-value="value"
                  v-model="item.conceptStatus"
                  hide-details
                  dense
                  @change="changeConceptStatus"
                ></v-select>
                <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'conceptStatus')">
                  <v-icon class="cursor-pointer" title="Close" x-small>check</v-icon>
                </v-btn>
                <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('conceptStatusEdit', item, false)">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                </v-btn>
              </div>
              <v-chip :color="conceptStatusClr(item.conceptStatus)" v-if="!item.conceptStatusEdit" small>
                <span :class="`statusdisplay-${item.conceptStatus}`">{{conceptStatusDisplay(item.conceptStatus)}}</span>
              </v-chip>
              <v-btn color="secondary" icon x-small @click="changeCreatorConceptEdit('conceptStatusEdit', item, true)" v-if="!item.conceptStatusEdit && isNotClient">
                <v-icon class="cursor-pointer" color="secondary" title="Update" x-small>edit</v-icon>
              </v-btn>
              
            </div>
          </template>
          <template v-slot:[`item.contentScripts`]="{ item }">
            <td class="text-right">
              <!-- <div class="d-flex flex-row" v-if="item.contentScriptsEdit">
                <v-text-field
                  style="max-width:320px"
                  v-if="item.contentScriptsEdit"
                  v-model="item.contentScripts"
                  dense
                  hide-details
                ></v-text-field>
                <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'contentScripts')">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                </v-btn>
                <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('contentScriptsEdit', item, false)">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                </v-btn>
              </div> -->
              <div class="d-flex flex-row">
                <!-- <v-chip
                  style="min-width:20px"
                  small
                  color="default"
                  :href="item.contentScripts"
                  :target="'_blank'"
                  v-if="item.contentScripts"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on"> 
                        <v-icon class="cursor-pointer" color="secondary" title="Link" small>mdi-link-variant</v-icon>
                        @{{item.userHandle}}_storyboard_{{item.campaignName}}
                      </span>
                    </template>
                    <span>View Content Scripts</span>
                  </v-tooltip>
                </v-chip> -->
                <!-- <v-btn
                  class="pr-0"
                  v-if="item.contentScripts"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  @click="downloadPDF(item)"
                >
                  <v-icon>download</v-icon>
                  <span>Download PDF</span>
                </v-btn> -->
                <!-- <div>
                  <v-btn
                    @click="copyContentScriptFormLink(item)"
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                    <span>Copy link</span>
                  </v-btn>
                </div> -->
                <!-- <v-btn class="pt-2" color="secondary" text x-small :to="'/creator/concept-form/' + item.pairingID" v-if="item.contentScriptForm" target="_blank">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }"> 
                      <v-icon class="cursor-pointer" color="secondary" title="Update" v-on="on" x-small>edit</v-icon>
                    </template>
                    <span>Edit Content Scripts</span>
                  </v-tooltip>
                </v-btn> -->
                <v-btn
                  v-if="item.contentScriptForm"
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  @click="viewContentScriptDialog(item.pairingID)"
                >
                  <v-icon color="secondary" small>edit</v-icon> <span v-if="isClient">View</span>  <span v-if="!isClient">Edit</span>
                </v-btn>
                <v-btn
                  v-if="item.contentScriptForm && !isClient"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  @click="downloadWord(item)"
                >
                  <v-icon color="success" small>download</v-icon> Download
                </v-btn>
                <div>
                  <v-btn
                    v-if="!isClient"
                    @click="copyContentScriptFormLink(item)"
                    color="secondary"
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                  >
                    <v-icon small>mdi-content-copy+</v-icon>
                    <span>Copy link</span>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.postingLink`]="{ item }">
            <div class="d-flex flex-row" v-if="item.postingLinkEdit">
              <v-text-field
                style="max-width:320px"
                v-if="item.postingLinkEdit"
                v-model="item.postingLink"
                dense
                hide-details
              ></v-text-field>
              <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'postingLink')">
                <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
              </v-btn>
              <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('postingLinkEdit', item, false)">
                <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
              </v-btn>
            </div>
            <div v-if="!item.postingLinkEdit">
              <v-btn
                class="pa-0 ma-0"
                style="min-width:20px"
                text
                small
                color="secondary"
                :href="item.postingLink"
                :target="'_blank'"
                :disabled="!item.postingLink"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }"> 
                    <v-icon class="cursor-pointer" color="secondary" title="Link" v-on="on" small>mdi-link-variant</v-icon>
                  </template>
                  <span>View Posting Link</span>
                </v-tooltip>
              </v-btn>
              <v-btn color="secondary" text x-small @click="changeCreatorConceptEdit('postingLinkEdit', item, true)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }"> 
                    <v-icon class="cursor-pointer" color="secondary" title="Update" v-on="on" x-small>edit</v-icon>
                  </template>
                  <span>Edit Posting Link</span>
                </v-tooltip>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.shootDate`]="{ item }">
            <td class="text-right">
              <div v-if="item.shootDateEdit">
                <!-- <v-text-field
                  style="max-width:120px"
                  v-if="item.shootDateEdit"
                  v-model="item.shootDate"
                  dense
                  hide-details
                ></v-text-field> -->
                <div class="d-flex flex-row">
                  <v-text-field
                    class="edit-date-box"
                    v-model="item.shootDate"
                    outlined
                    dense
                    hide-details
                    @input="checkActDate(item, item.shootDate)"
                    @keyup.enter="checkActDate(item, item.shootDate)"
                  >
                  </v-text-field>
                  <div class="date-picker-inner">
                    <date-picker
                      className="input-field"
                      :options="{theme: 'icon', confirm: true}"
                      :status="item.actEndDateCal"
                      @changeDate="setActDateFromPicker(item, ...arguments)"
                    />
                  </div>
                </div>
                <div class="d-flex flex-row justify-right" v-if="item.shootDateEdit">
                  <v-btn color="success btn-edit-mth mr-1 ml-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'shootDate')" :disabled="item.invalidShootDate">
                    <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                  </v-btn>
                  <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('shootDateEdit', item, false)">
                    <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                  </v-btn>
                </div>
              </div>
              <div v-if="!item.shootDateEdit">
                {{item.shootDate}}
                <v-btn color="secondary" icon x-small @click="changeCreatorConceptEdit('shootDateEdit', item, true)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }"> 
                      <v-icon class="cursor-pointer" color="secondary" title="Update" v-on="on" x-small>edit</v-icon>
                    </template>
                    <span>Edit Shoot Date</span>
                  </v-tooltip>
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:[`item.deliverableDetails`]="{ item }">
            <div>
              <p class="deliverable-txt mb-0">
                {{campaignHelper.getDeliverableDetails(item.deliverableDetails)}}
              </p>
            </div>
          </template>
          <template v-slot:[`item.contentFeature`]="{ item }">
            <td class="text-right pa-2">
              <v-textarea
                style="min-width:150px;max-width:320px"
                v-if="item.contentFeatureEdit"
                v-model="item.contentFeature"
                dense
                outlined
                hide-details
              ></v-textarea>
              <div class="d-flex flex-row justify-right" v-if="item.contentFeatureEdit">
                <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'contentFeature')">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                </v-btn>
                <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('contentFeatureEdit', item, false)">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                </v-btn>
              </div>
              <div v-if="!item.contentFeatureEdit">
                {{item.contentFeature}}
                <v-btn color="secondary" icon x-small @click="changeCreatorConceptEdit('contentFeatureEdit', item, true)" v-if="!isClient">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }"> 
                      <v-icon class="cursor-pointer" color="secondary" title="Update" v-on="on" x-small>edit</v-icon>
                    </template>
                    <span>Edit Content feature/pillar</span>
                  </v-tooltip>
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:[`item.kobeRemark`]="{ item }">
            <td class="text-right pa-2">
              <v-textarea
                style="min-width:150px;max-width:320px"
                v-if="item.kobeRemarkEdit"
                v-model="item.kobeRemark"
                dense
                outlined
                hide-details
              ></v-textarea>
              <div class="d-flex flex-row justify-right" v-if="item.kobeRemarkEdit">
                <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updateCreatorConcept(item, 'kobeRemark')">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                </v-btn>
                <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changeCreatorConceptEdit('kobeRemarkEdit', item, false)">
                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                </v-btn>
              </div>
              <div v-if="!item.kobeRemarkEdit">
              <v-tooltip bottom color="black" max-width="300px">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <p class="remark-text">{{item.kobeRemark || '-'}}</p>
                  </div>
                </template>
                <span v-html="formatDesc(item.kobeRemark)"></span>
              </v-tooltip>
                <v-btn color="secondary" icon x-small @click="changeCreatorConceptEdit('kobeRemarkEdit', item, true)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }"> 
                      <v-icon class="cursor-pointer" color="secondary" title="Update" v-on="on" x-small>edit</v-icon>
                    </template>
                    <span>Edit Content feature/pillar</span>
                  </v-tooltip>
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td class="text-center" style="width:170px">
              <v-btn
                small
                color="error"
                @click="changeRelease(item, false)"
                v-if="item.releaseContentScript"
              >
                Suspend
                <v-icon color="white" small>mdi-close-circle</v-icon> 
              </v-btn>
              <v-btn
                small
                color="primary"
                @click="changeRelease(item, true)"
                v-if="!item.releaseContentScript"
              >
                Release
                <v-icon color="white" small>mdi-check</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- Content Scripts URL Modal Dialog -->
    <content-script-edit-dialog
    v-model="contentScriptEditDialog"
    :value="contentScriptEditDialog"
    :item="pairingItem"
    @saveClicked="saveContentScript"
    />
    <!-- post link update dialog -->
    <post-link-update-modal
    v-model="postLinkUpdateDialog"
    :value="postLinkUpdateDialog"
    :item="pairingItem"
    @saveClicked="savePostLink"
    />
    <!-- table cols show hide dialog -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Creator Concept Columns"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- View content scripts modal -->
    <view-creator-concept-modal-dialog
    v-model="viewcontentScriptModalDialog"
    :value="viewcontentScriptModalDialog"
    :data="viewContentScriptsData"
    v-if="viewContentScriptsData"/>
    <input type="hidden" id="copy-concept-link" :value="conceptFormLink">
    <!-- end of table cols show hide dialog -->
    <v-snackbar
      v-model="copySucceeded"
    >
      Copied to Clipboard!
      <v-btn
        color="blue"
        text
        @click="copySucceeded = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <!-- creator concept -->
    <input type="hidden" id="copy-concept-link" :value="conceptFormLink">
    <!-- loading -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import utils from '@/utils';
import config from '@/config';
import creatorConceptConfig from './config';
import SocialHandle from '@/components/scoped/custom/SocialHandle'
import ContentScriptEditDialog from './ContentScriptEditDialog';
import PostLinkUpdateModal from './PostLinkUpdateModal';
import campaignHelper from '../../Campaign/campaignHelper';
import campaignPDF from '../../Campaign/campaignPDF';
import pairingAPIs from '../pairingAPIs';
import Loading from 'vue-loading-overlay';
import DatePicker from '@/components/scoped/custom/DatePicker'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import ViewCreatorConceptModalDialog from './ViewModalDialog'
import Speed from '../../AMDashboard/speed.vue';
import HTMLToPDF from '../../../editor/generator/HTMLToPDF'
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import ContentWordGenerator from './ContentWordGenerator';
import ContentPDFGenerator from './ContentPDFGenerator';
// import campaignAPIs from '../../Campaign/campaignAPIs';
export default {
  name: 'PairedCreators',
  components: {
    SocialHandle,
    ContentScriptEditDialog,
    ViewCreatorConceptModalDialog,
    PostLinkUpdateModal,
    TableColsShowHideModal,
    Loading,
    DatePicker,
    Speed
  },
  data() {
    return {
      headers: creatorConceptConfig.headers,
      conceptStatuses: creatorConceptConfig.conceptStatuses,
      campaignHelper,
      filteredCampaign: null,
      filters: {
        keyword: '',
        status: '',
        campaignIDs: []
      },
      filteredItems: [],
      contentScriptEditDialog: false,
      postLinkUpdateDialog: false,
      pairingItem: null,
      isLoading: false,
      filterTxt: '',
      currentPage: 1,
      rowsPerPageItems: [10, 20, 50, 100, { text: 'All', value: -1 }],
      pagination: {
        // v-data-table pagination
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: [],
        itemsPerPage: 15
      },
      totalItems: 0,
      tableColsItems: [],
      colSettingsDialog: false,
      copySucceeded: false,
      viewcontentScriptModalDialog: false,
      viewContentScriptsData: null,
      colStatuses: {},
      conceptFormLink: ''
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns,
      pairings: state => state.pairing.pairings
    }),
    computedHeaders() {
      let creatorConceptCols = null
      // set col statuses from user table
      if (this.filteredCampaign && this.filteredCampaign.tableSettings) {
        if (this.filteredCampaign.tableSettings.creatorConceptCols) {
          creatorConceptCols = Object.assign({}, this.filteredCampaign.tableSettings.creatorConceptCols)
        }
      }
      this.headers.map(header => {
        this.colStatuses[header.value] = true
      })
      if (creatorConceptCols) {
        for (var key of Object.keys(creatorConceptCols)) {
          this.colStatuses[key] = creatorConceptCols[key]
        }
      }
      let clientHeaderNames = [
        // 'conceptStatus',
        'shootDate',
        'action'
        // 'contentFeature',
        // 'kobeRemark'
      ]
      return this.headers.filter(h => {
        if (this.isClient) {
          if (clientHeaderNames.includes(h.value)) {
            return false
          }
        }
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      })
    },
    payload() {
      if (this.filteredCampaign) {
        // if filtered, use filtered campaigns
        this.filters.campaignIDs = [this.filteredCampaign.id]
      } else {
        // else pairing, ongoing campaigns
        this.filters.campaignIDs = this.campaigns.map(c => c.id)
      }
      return {
        filter: this.filters,
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    },
    filterStatuses() {
      let statuses = Object.assign([], this.conceptStatuses)
      statuses.unshift({
        text: 'All',
        value: ''
      })
      return statuses
    },
    clientID() {
      return this.$store.state.user.clientID
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isClient: function() {
      return config.userRoles.CLIENT === this.currentUserRole;
    },
    isNotClient: function() {
      return config.userRoles.CLIENT !== this.currentUserRole;
    }
  },
  watch: {
    pagination(newVal) {
      this.paginate(newVal.page);
    }
  },
  mounted: async function() {
    setTimeout(() => {
      pdfMake.fonts = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      }
    }, 1000);
    let filters = {
      statuses: [
        config.campaignStatus.PAIRING_INFLUENCER,
        config.campaignStatus.ONGOING,
        config.campaignStatus.REVIEW
      ]
    }
    if (this.isClient) filters.clientID = this.clientID || null
    await this.$store.dispatch('campaign/getCampaigns', {
      filters: filters
    })
    this.paginate()
    // this.getPairedInfluencers()
  },
  methods: {
    async paginate(page = 1) {
      this.isLoading = true
      this.currentPage = page;
      this.payload.paging.page = page;
      await this.$store.dispatch('pairing/getCreatorConceptPairing', this.payload)
      if (this.pairings.data) {
        this.filteredItems = [];
        for (let data of this.pairings.data) {
          let inf = this.beautifyData(data);
          this.filteredItems.push(inf);
        }
        this.totalItems = this.pairings.total;
        if (this.pagination.itemsPerPage === -1) {
          this.pagination.itemsPerPage = 20;
        }
        if (this.isClient) {
          this.filteredItems = this.filteredItems.filter(f => f.contentScriptForm && f.releaseContentScript)
        }
        if (this.$route.query.id) {
          this.viewContentScriptDialog(this.$route.query.id)
        }
        this.isLoading = false
      }
    },
    beautifyData(data) {
      const deliverablesDetails = data.deliverables_details || {};
      let inf = Object.assign({}, data.influencer_details || {});
      inf.deliverableDetails = deliverablesDetails
      inf.pairingID = data.id
      inf.concept_details = data.concept_details || {};
      inf.conceptStatus = inf.concept_details.conceptStatus || 1;
      inf.contentScripts = inf.concept_details.contentScripts || '';
      inf.postingLink = inf.concept_details.postingLink || '';
      inf.contentFeature = inf.concept_details.contentFeature || '';
      inf.kobeRemark = inf.concept_details.kobeRemark || '';
      inf.shootDate = inf.concept_details.shootDate || '';
      inf.campaignID = data.campaignID
      inf.platform = String(inf.platform || 'instagram').toLowerCase()
      if (inf.platform === 'x') inf.platform = 'twitter'
      inf.contentScriptForm = data.contentScriptForm || false;
      inf.releaseContentScript = data.releaseContentScript || false;
      inf.invalidShootDate = false
      inf.conceptStatusEdit = false
      inf.contentScriptsEdit = false
      inf.postingLinkEdit = false
      inf.shootDateEdit = false
      inf.contentFeatureEdit = false
      inf.kobeRemarkEdit = false
      if (!inf.userHandle) {
        inf.userHandle = inf.platform === 'twitter'
          ? (inf.twitterHandle || inf.instagramHandle)
          : (inf.linkedinHandle || inf.instagramHandle)
      }
      if (inf.campaignID) {
        let matchCampaign = this.campaigns.find(c => c.id === data.campaignID)
        if (matchCampaign) {
          inf.campaignName = matchCampaign.name
        }
      }
      return inf;
    },
    conceptStatusDisplay(value) {
      const matchedItem = creatorConceptConfig.conceptStatuses.find(item => item.value === value);
      if (matchedItem) {
        return matchedItem.text;
      } else {
        return '';
      }
    },
    async saveContentScript(item) {
      let conptDetls = item.concept_details || {}
      conptDetls.contentScripts = item.contentScripts
      let updatePairings = [{
        id: item.pairingID,
        'concept_details': conptDetls
      }]
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (resp) {
        let matchItemIdx = this.filteredItems.findIndex(f => f.pairingID === item.pairingID)
        if (matchItemIdx !== -1) {
          this.filteredItems[matchItemIdx].contentScripts = item.contentScripts
          this.filteredItems = utils.func.refreshJSON(this.filteredItems)
        }
        this.$swal({
          type: 'success',
          text: 'Successfully Saved.'
        });
      }
    },
    async savePostLink(item) {
      let conptDetls = item.concept_details || {}
      conptDetls.postingLink = item.postingLink
      let updatePairings = [{
        id: item.pairingID,
        'concept_details': conptDetls
      }]
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (resp) {
        let matchItemIdx = this.filteredItems.findIndex(f => f.pairingID === item.pairingID)
        if (matchItemIdx !== -1) {
          this.filteredItems[matchItemIdx].postingLink = item.postingLink
          this.filteredItems = utils.func.refreshJSON(this.filteredItems)
        }
      }
    },
    async updateCreatorConcept(item, field) {
      this.isLoading = true
      let conptDetls = item.concept_details || {}
      conptDetls[field] = item[field]
      let updatePairings = [{
        id: item.pairingID,
        'concept_details': conptDetls
      }]
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (resp) {
        let matchItemIdx = this.filteredItems.findIndex(f => f.pairingID === item.pairingID)
        if (matchItemIdx !== -1) {
          this.filteredItems[matchItemIdx][field] = item[field]
          this.filteredItems = utils.func.refreshJSON(this.filteredItems)
          if (this.filteredItems[matchItemIdx][`${field}Edit`]) {
            this.filteredItems[matchItemIdx][`${field}Edit`] = false
          }
        }
      }
      this.isLoading = false
    },
    changeCreatorConceptEdit(colName, item, status) {
      let matchItemIdx = this.filteredItems.findIndex(f => f.pairingID === item.pairingID)
      if (matchItemIdx !== -1) {
        this.filteredItems[matchItemIdx][colName] = status
        this.filteredItems = utils.func.refreshJSON(this.filteredItems)
      }
    },
    openContentScriptEditModal(item) {
      this.pairingItem = Object.assign({}, item)
      this.contentScriptEditDialog = true
    },
    openPostLinkEditModal(item) {
      this.pairingItem = Object.assign({}, item)
      this.postLinkUpdateDialog = true
    },
    searchFilter() {
      this.paginate(1)
    },
    resetFilter() {
      this.filteredCampaign = null
      this.filters = {
        keyword: '',
        campaignIDs: []
      }
      this.searchFilter()
    },
    conceptStatusClr(value) {
      const matchedItem = creatorConceptConfig.conceptStatuses.find(item => item.value === value);
      if (matchedItem) {
        return matchedItem.color;
      } else {
        return '';
      }
    },
    checkActDate(item, dateVal) {
      item.invalidShootDate = true
      if (utils.func.isDateFormatValid(dateVal) || !dateVal) {
        item.invalidShootDate = false
      }
    },
    setActDateFromPicker(item, value) {
      item.shootDate = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.checkDate(item.shootDate)
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.filteredCampaign.tableSettings) {
        tableSettings = this.filteredCampaign.tableSettings
      }
      tableSettings.creatorConceptCols = Object.assign({}, columns)
      let updateData = [{
        id: this.filteredCampaign.id,
        tableSettings
      }]
      await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
      this.filteredCampaign.tableSettings = Object.assign({}, tableSettings)
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    exportExcel() {
      // Export excel creator concepts
      this.isLoading = true
      this.payload.export = true
      pairingAPIs
        .downloadCreatorConceptRpt(this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading creator concepts report', error);
        });
    },
    async downloadPDF(item) {
      const htmlToPdf = new HTMLToPDF(item.contentScripts, 'Arial')
      let pdfData = await htmlToPdf.generate()
      pdfMake.createPdf(pdfData).download(item.userHandle + '_content_scripts.pdf');
    },
    copyContentScriptFormLink(pairing) {
      this.copySucceeded = true
      const protocol = window.location.protocol
      const host = window.location.host
      this.conceptFormLink = `${protocol}//${host}/influencers/content-storyboard/${pairing.pairingID}`
      setTimeout(function() {
        pairing.linkCopied = utils.func.copyToClipboard('#copy-concept-link')
      }, 100)
    },
    async viewContentScriptDialog(id) {
      this.viewContentScriptsData = {}
      this.viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(id)
      if (!this.viewContentScriptsData) {
        this.$swal({
          text: 'No Content Scripts Data.',
          type: 'secondary'
        })
      }
      this.viewcontentScriptModalDialog = true
    },
    async downloadWord(item) {
      this.viewContentScriptsData = {}
      this.viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(item.pairingID)
      if (!this.viewContentScriptsData) {
        this.$swal({
          text: 'No Content Scripts Data.',
          type: 'secondary'
        })
      }
      ContentWordGenerator.generateDocument(this.viewContentScriptsData)
      // let vm = this
      // setTimeout(function() {
      //   // let fonts = {
      //   //   NotoSans: {
      //   //     normal: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf',
      //   //     bold: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-700-normal.ttf'
      //   //   }
      //   // };
      //   pdfMake.fonts = {
      //     Arial: {
      //       normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
      //       bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
      //       italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
      //     }
      //   }
      //   pdfMake.createPdf(doc).download(item.userHandle + '_content_scripts.pdf');
      // }, 1000)
      // Create a table with 2 rows and 3 columns
      //   const titleTxt = new Paragraph({
      //     children: [
      //       // new TextRun('Hello World'),
      //       // new TextRun({
      //       //   text: 'Foo Bar',
      //       //   bold: true
      //       // }),
      //       new TextRun({
      //         text: 'Content Storyboard Flow',
      //         bold: true
      //       })
      //     ]
      //   })
      //   // const table = new Table({
      //   //   rows: [
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //   ],
      //   // });
      //   const doc = new Document({
      //     sections: [
      //       {
      //         properties: {},
      //         children: [
      //           titleTxt
      //         ]
      //       }
      //     ]
      //   });

      //   Packer.toBlob(doc).then((blob) => {
      //     console.log(blob);
      //     saveAs(blob, 'example.docx');
      //     console.log('Document created successfully');
      //   });
      // }
    },
    async sendPdf(id) {
      this.viewContentScriptsData = {}
      this.viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(id)
      if (!this.viewContentScriptsData) {
        this.$swal({
          text: 'No Content Scripts Data.',
          type: 'secondary'
        })
      }
      let doc = ContentPDFGenerator.generatePDF(this.viewContentScriptsData)
      // let vm = this
      // setTimeout(function() {
      //   // let fonts = {
      //   //   NotoSans: {
      //   //     normal: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf',
      //   //     bold: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-700-normal.ttf'
      //   //   }
      //   // };
      //   pdfMake.fonts = {
      //     Arial: {
      //       normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
      //       bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
      //       italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
      //     }
      //   }
      //   pdfMake.createPdf(doc).download(`asdfasfsadf.pdf`);
      // }, 1000)
      campaignPDF
      .generatePDF(doc)
      .then(async (pdfData) => {
        let bfsBaseFmt = await campaignPDF.generateBasePDF(doc)
        let formData = new FormData();
        formData.append('pairingID', id)
        formData.append('contentFileBase', bfsBaseFmt)
        formData.append('contentFile', pdfData)
        await pairingAPIs.sendContentFlowEmail(formData)
        return true
      })
      .catch(error => {
        console.log('error in converting PDF', error);
      });
      // Create a table with 2 rows and 3 columns
      //   const titleTxt = new Paragraph({
      //     children: [
      //       // new TextRun('Hello World'),
      //       // new TextRun({
      //       //   text: 'Foo Bar',
      //       //   bold: true
      //       // }),
      //       new TextRun({
      //         text: 'Content Storyboard Flow',
      //         bold: true
      //       })
      //     ]
      //   })
      //   // const table = new Table({
      //   //   rows: [
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Header 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 1, Cell 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //     new TableRow({
      //   //       children: [
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 1")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 2")],
      //   //         }),
      //   //         new TableCell({
      //   //           children: [new Paragraph("Row 2, Cell 3")],
      //   //         }),
      //   //       ],
      //   //     }),
      //   //   ],
      //   // });
      //   const doc = new Document({
      //     sections: [
      //       {
      //         properties: {},
      //         children: [
      //           titleTxt
      //         ]
      //       }
      //     ]
      //   });

      //   Packer.toBlob(doc).then((blob) => {
      //     console.log(blob);
      //     saveAs(blob, 'example.docx');
      //     console.log('Document created successfully');
      //   });
      // }
    },
    async sendClientNoPdf(id) {
      let formData = new FormData();
      formData.append('pairingID', id)
      formData.append('noPdf', true)
      await pairingAPIs.sendContentFlowEmail(formData)
    },
    changeRelease(item, status) {
      const spTxt = status ? 'Release' : 'Suspend'
      // this.sendPdf(item.pairingID)
      this.$swal({
        title: `Are you sure to ${spTxt}?`,
        icon: 'secondary',
        confirmButtonText: 'Confirm',
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          let updatePairings = [{
            id: item.pairingID,
            releaseContentScript: status
          }]
          let formData = new FormData();
          formData.append('pairings', JSON.stringify(updatePairings));
          let resp = await pairingAPIs.updatePairings(formData)
          if (resp) {
            // Show success message
            this.$swal({
              text: `Successfully ${status ? 'Released' : 'Suspended'}.`,
              type: 'success'
            });
            let matchItemIdx = this.filteredItems.findIndex(f => f.pairingID === item.pairingID)
            if (matchItemIdx !== -1) {
              this.filteredItems[matchItemIdx].releaseContentScript = status
              this.filteredItems = utils.func.refreshJSON(this.filteredItems)
            }
            if (status) {
              this.sendClientNoPdf(item.pairingID)
            }
          } else {
            this.$swal({
              text: 'Error Release.',
              type: 'error'
            });
            return
          }
          item.releaseContentScript = status
          // this.getCampaigns()
        }
      })
    },
    formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>')
      }
      return text
    }
  }
}
</script>
<style scoped>
  .creator_concept_page__table .btn-edit-mth {
    max-width: 20px!important;
    min-width: 20px!important;
    padding: 0!important;
  }
  .creator_concept_page__table .statusdisplay-9 {
    color: #fff;
  }
  .creator_concept_page__table .deliverable-txt {
    overflow-wrap: break-word;
  }
  .edit-date-box {
    min-width: 150px;
    max-width: 200px;
  }
  .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
</style>
<style>
  .creator_concept_page__table th.creator-handle-column,
  .creator_concept_page__table td.creator-handle-column {
    min-width: 210px;
  }
  .creator_concept_page__table tbody td .remark-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
    max-height: 100px;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?09171dbc